import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import DateRangeField from '../common/DateRangeField';
import SharedFilters from '../common/SharedFilters';
import ViewAsSwitch from '../common/ViewAsSwitch';

const KeyboardingFilter = () => {
  const classes = useStyles();

  return (
    <>
      <SharedFilters />
      <Grid xs={12} md={6} lg item className={classes.dateRangeField}>
        <DateRangeField />
      </Grid>
      <Grid item>
        <ViewAsSwitch />
      </Grid>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  [theme.breakpoints.up('sm')]: {
    dateRangeField: {
      minWidth: '140px',
      maxWidth: '240px'
    }
  }
}));

export default KeyboardingFilter;
